module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "pvi"
    }
  }), _c('a', {
    attrs: {
      "id": "pvii"
    }
  }), _vm._v(" "), _c('blockquote', {
    staticClass: "sink"
  }, [_c('p', {
    staticClass: "left "
  }, [_vm._v("“The wrongs which we seek to condemn and punish have been so calculated, so malignant, and so devastating, that civilization cannot tolerate their being ignored, because it cannot survive their being repeated.”")]), _vm._v(" "), _c('p', {
    staticClass: "right "
  }, [_vm._v("—"), _c('em', [_vm._v("Robert H. Jackson, Nuremberg prosecutor (1945)")])])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left "
  }, [_vm._v("“It is all forgotten. It’s all over.”")]), _vm._v(" "), _c('p', {
    staticClass: "right "
  }, [_vm._v("—"), _c('em', [_vm._v("Jakob Reimer, former Nazi SS officer living outside New York City (1998)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-134c44ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front03.vue
// module id = 66
// module chunks = 0